import { ca } from '@cian/analytics';

export function trackLeaveClick() {
  ca('eventSite', {
    name: 'oldevent',
    category: 'B2BLanding',
    action: 'Click',
    label: 'LeaveRequestFloat',
  });
}
